class ICoreCountUp {
    observer = null;

    constructor() {
        const elements = document.querySelectorAll('.icore-stat-card__num[data-count]');

        if (!elements.length) {
            return;
        }

        this.observer = new IntersectionObserver(
            (entries) => entries.forEach((entry) => this.#onIntersect(entry)),
            { threshold: 0.5 }
        );

        elements.forEach((el) => this.observer.observe(el));
    }

    #onIntersect(entry) {
        if (!entry.isIntersecting) {
            return;
        }

        const el = entry.target;
        const target = Number(el.dataset.count);
        const suffix = el.dataset.suffix || '';
        const prefix = el.dataset.prefix || '';

        if (Number.isNaN(target)) {
            this.observer.unobserve(el);
            return;
        }

        let current = 0;
        const step = target / 40;

        const run = () => {
            current += step;

            if (current < target) {
                el.textContent = prefix + Math.floor(current) + suffix;
                requestAnimationFrame(run);
            } else {
                el.textContent = prefix + target + suffix;
            }
        };

        run();
        this.observer.unobserve(el);
    }

    destroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
}

export default ICoreCountUp;
